import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiV1, apiV2 } from "../Auth/Interceptor";

const initialStateValue = {
  activeTab: "all",
  orders: {
    orders: [],
    loading: "idle",
    error: null,
  },
  returnOrders: {
    orders: [],
    loading: "idle",
    error: null,
  },
  orderKebab: {
    kebabOpen: false,
    orderId: null,
  },
  modal: {
    activeModal: "",
    displayModal: false,
  },
};

const fetchOrders = createAsyncThunk("orders/fetchOrders", async () => {
  try {
    const response = await apiV1.get(`ordermanage/getOrders`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
});

const fetchReturnOrders = createAsyncThunk("orders/ReturnOrders", async () => {
  try {
    const response = await apiV2.get(`seller/orderReturn`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
});

const orderManagementSlice = createSlice({
  name: "orderManagement",
  initialState: initialStateValue,
  reducers: {
    changeTab: (state, action) => {
      state.activeTab = action.payload;
    },
    openOrderKebabMenu: (state, action) => {
      state.orderKebab.kebabOpen = true;
      state.orderKebab.orderId = action.payload;
    },
    closeOrderKebabMenu: (state, _) => {
      state.orderKebab = initialStateValue.orderKebab;
    },
    resetOrderKebabId: (state) => {
      state.orderKebab.orderId = null;
    },
    resetOrderKebabOpen: (state) => {
      state.orderKebab.kebabOpen = false;
    },
    setModal: (state, action) => {
      state.modal.activeModal = action.payload;
      state.modal.displayModal = true;
    },
    closeModal: (state, _) => {
      state.modal.activeModal = "";
      state.modal.displayModal = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.orders.loading = "loading";
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.orders.loading = "succeeded";
        state.orders.orders = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.orders.loading = "failed";
        state.orders.error = action.error.message;
      })

      .addCase(fetchReturnOrders.pending, (state) => {
        state.returnOrders.loading = "loading";
      })
      .addCase(fetchReturnOrders.fulfilled, (state, action) => {
        state.returnOrders.loading = "succeeded";
        state.returnOrders.orders = action.payload;
      })
      .addCase(fetchReturnOrders.rejected, (state, action) => {
        state.returnOrders.loading = "failed";
        state.returnOrders.error = action.error.message;
      });
  },
});

export const {
  changeTab,
  openOrderKebabMenu,
  closeOrderKebabMenu,
  resetOrderKebabId,
  resetOrderKebabOpen,
  setModal,
  closeModal,
} = orderManagementSlice.actions;

export { fetchOrders, fetchReturnOrders };

export default orderManagementSlice.reducer;
